import NavbarMenuItem from "./NavbarMenuItem/NavbarMenuItem";
import {useUIConfig} from '../../../hooks/config/useUIConfig';
import {PATHS} from '../../../router/paths';
import { useKeycloak } from "@react-keycloak/web";

const NavbarMenu = () => {
	const { keycloak, initialized } = useKeycloak();


	const config = {config: { menu: [] }};//useUIConfig();
	
	// if(config.config.menu == null)
	// 	return <></>;

	const staticMenu = [
		{
			name: 'maps',
		 	link: PATHS.root
		}
	];

	// const staticMenuAuth = [
	// 	{
	// 		name: 'backend',
	// 	 	link: PATHS.backend
	// 	}
	// ];

	const authenticated = initialized && keycloak.authenticated;

	const menu = staticMenu.concat(config.config.menu);

	return (
		<>
			{/* <NavbarMenuItem to={PATHS.charts} name={"charts"} auth={true}/>
			<NavbarMenuItem to={PATHS.orderbook} name={"orderbook"} auth={true}/> */}
			{/* <NavbarMenuItem to={PATHS.terminal} name={"terminal"} auth={true}/> */}
			{/* <NavbarMenuItem to={PATHS.create_order} name={"create order"} auth={true}/> */}
			{/* {staticMenuAuth.map(({name, link}) => (
				<NavbarMenuItem key={link} to={link} name={name} auth={true}/>
			))} */}
			{staticMenu.map(({name, link}) => (
				<NavbarMenuItem key={link} to={link} name={name}/>
			))}
		</>
	);

}

export default NavbarMenu;